import { useEffect, useState } from 'react';

/**
 * React hook that tracks whether a CSS media query currently matches,
 * re-rendering when the match state changes (e.g. on rotation/resize).
 *
 * Used to switch between phone/desktop renderings in JS where pure CSS
 * (nth-child column hiding) is too brittle — see PlayersList, where the
 * phone view renders a user-selected stat column instead of all eleven.
 *
 * @param {string} query - Media query string, e.g. '(max-width: 480px)'.
 * @returns {boolean} True while the query matches the viewport.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
